import { render, staticRenderFns } from "./StatusBind.vue?vue&type=template&id=c9f10fb8&"
import script from "./StatusBind.vue?vue&type=script&lang=ts&"
export * from "./StatusBind.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports